"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractFilterTypeFromFilterJaql = exports.getFilterType = exports.isConditionFilter = exports.isNumericRangeFilter = exports.isSpecificItemsFilter = void 0;
const condition_filter_util_js_1 = require("./condition-filter-util.js");
const types_js_1 = require("./types.js");
const date_time_filter_util_js_1 = require("./date-time-filter-util.js");
const isIncludeAllFilter = (filter) => filter === null || filter === void 0 ? void 0 : filter.all;
const getInnerPeriodFilter = (filter) => (filter.last ? filter.last : filter.next);
const isPeriodFilter = (filter) => { var _a; return ((_a = getInnerPeriodFilter(filter)) === null || _a === void 0 ? void 0 : _a.offset) < 2; };
const isSpecificItemsFilter = (filter) => { var _a; return ((_a = filter === null || filter === void 0 ? void 0 : filter.members) === null || _a === void 0 ? void 0 : _a.length) >= 0; };
exports.isSpecificItemsFilter = isSpecificItemsFilter;
const isFromOrToDefined = (fromRange, toRange) => (fromRange && typeof fromRange === 'string') || (toRange && typeof toRange === 'string');
const isFromAndToEmpty = (from, to) => from === '' && to === '';
const isDateRangeFilter = (filter, dataType) => {
    const { from, to } = filter;
    if (dataType !== types_js_1.FilterModalType.DATE_TIME)
        return false;
    if (isFromOrToDefined(from, to))
        return true;
    return isFromAndToEmpty(from, to);
};
const isNumericRangeFilter = (filter) => {
    const { from, to } = filter;
    return !!(from !== undefined && to !== undefined && !filter.isBetween);
};
exports.isNumericRangeFilter = isNumericRangeFilter;
const isConditionFilter = (filter) => (0, condition_filter_util_js_1.getSelectedConditionOption)(filter) !== types_js_1.ConditionFilterType.NONE;
exports.isConditionFilter = isConditionFilter;
const isAdvancedFilter = (filter) => Object.keys(filter).includes('isAdvanced');
const isTimeLevelNotSupported = (timeData) => !!(timeData.level &&
    timeData.bucket &&
    timeData.level === types_js_1.DatetimeLevel.MINUTES &&
    types_js_1.nonSupportedMinutesBuckets.includes(timeData.bucket));
const isInvalidFilter = (filter) => filter.filterType === types_js_1.FILTER_TYPES.INVALID;
const getFilterType = (filter, dataType = types_js_1.FilterModalType.DATE_TIME, timeData) => {
    if (timeData && isTimeLevelNotSupported(timeData))
        return types_js_1.FILTER_TYPES.ADVANCED;
    if (isAdvancedFilter(filter))
        return types_js_1.FILTER_TYPES.ADVANCED;
    if (isIncludeAllFilter(filter))
        return types_js_1.FILTER_TYPES.INCLUDE_ALL;
    if (isPeriodFilter(filter))
        return types_js_1.FILTER_TYPES.PERIOD;
    if ((0, exports.isSpecificItemsFilter)(filter))
        return types_js_1.FILTER_TYPES.SPECIFIC_ITEMS;
    if (isDateRangeFilter(filter, dataType))
        return types_js_1.FILTER_TYPES.DATE_RANGE;
    if ((0, exports.isNumericRangeFilter)(filter))
        return types_js_1.FILTER_TYPES.NUMERIC_RANGE;
    if ((0, exports.isConditionFilter)(filter))
        return types_js_1.FILTER_TYPES.CONDITION;
    if (isInvalidFilter(filter))
        return types_js_1.FILTER_TYPES.INVALID;
    return types_js_1.FILTER_TYPES.INVALID;
};
exports.getFilterType = getFilterType;
/**
 * Extracts Filter Type from Filter Jaql
 *
 * @param jaql - jaql
 * @param dataType - data type
 * @return FilterJaqlWrapperType
 * @internal
 */
const extractFilterTypeFromFilterJaql = (jaql, dataType) => {
    const { level: filterLevel, filter, bucket } = jaql;
    const filterFromJaql = filter || types_js_1.DEFAULT_FILTER_JAQL_WRAPPER.filter;
    const filterToReturn = {
        filter: Object.assign(Object.assign({}, filterFromJaql), { filterType: (0, exports.getFilterType)(filterFromJaql, dataType) }),
    };
    if (dataType === types_js_1.FilterModalType.DATE_TIME) {
        const backgroundFilter = filterFromJaql;
        const level = (backgroundFilter === null || backgroundFilter === void 0 ? void 0 : backgroundFilter.level) || filterLevel;
        filterToReturn.level = (0, date_time_filter_util_js_1.getCorrectTimeLevel)(level, bucket);
        filterToReturn.filter.filterType = (0, exports.getFilterType)(filterFromJaql, dataType, { level, bucket });
    }
    return filterToReturn;
};
exports.extractFilterTypeFromFilterJaql = extractFilterTypeFromFilterJaql;
